import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import HealthAndSafety from '@/components/HealthAndSafety'
import Contact from '@/components/Contact'
import Services from '@/components/Services'
import Projects from '@/components/Projects'
import Project from '@/components/Project'
import NotFound from '@/components/NotFound'

Vue.use(Router)

export default new Router({
	scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
//   mode: 'history',
  routes: [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta : {
			title: 'Foxdown Construction'
		}
	},
	{
		path: '/hands',
		name: "Health & Safety",
		component: HealthAndSafety,
		meta : {
			title: 'Health & Safety'
		}
	},
	{
		path: '/services',
		name: "Services",
		component: Services,
		meta : {
			title: 'Our Services'
		}
	},
	{
		path: '/projects',
		name: "Projects",
		component: Projects,
		meta : {
			title: 'Our Projects'
		}
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact,
		meta : {
			title: 'Contact Us'
		}
	},
	{
		path: '/*',
		name: 'Home',
		component: Home,
		meta : {
			title: 'Foxdown Construction'
		}
	},
	// {
	// 	path: '/*',
	// 	name: 'NotFound',
	// 	component: NotFound	
	// },
	{
		path: '/project/:projectName',
		name: 'Project',
		component: Project,
		props: true,
		meta : {
			title: 'Our Projects'
		}
	}
  ]
})
